import {
  TransactionStatus,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, multiSwitchMap } from '@principle-theorem/shared';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';

function isAccTransactionExtendedData(_data: unknown): _data is unknown {
  return true;
}

export class VoidAccTransaction implements ITransactionAction<unknown> {
  icon = 'block';
  label = 'Void';
  tooltip = 'Void if invoice has been manually cancelled via ACC';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isAccTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(data: ITransactionActionsData<unknown>): Observable<boolean> {
    const claimTransactions$ = of(data.claim?.transactions || []).pipe(
      multiSwitchMap((transactionRef) => Firestore.doc$(transactionRef))
    );

    return claimTransactions$.pipe(
      map((transactions) =>
        transactions.every(
          (transaction) =>
            transaction.type === TransactionType.Incoming &&
            transaction.status === TransactionStatus.Pending
        )
      )
    );
  }

  async do(data: ITransactionActionsData<unknown>): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.cancel(
      data.invoice,
      data.latestTransaction,
      'Void ACC Claim'
    );
    this.inProgress$.next(false);
  }
}
